<!--
    描述：分析规则配置页面
    时间：2021-09-24
    Created by 王帅
-->
<template>
    <div class="w-page-main">
        <div class="w-page-header">
            <search-area
                ref="searchContent"
                v-model="tableObj.sname"
                placeholderName="规则名称"
                @on-search="onSearch"
                @on-refresh="onRefresh"
                :showMore="false"
            >
            </search-area>
            <div class="btnGroups ml10">
                <el-button type="primary" size="small" @click="handleTool('add')"
                    >新增规则</el-button
                >
            </div>
        </div>

        <div class="w-page-container w-table-page">
            <div class="w-table-layout w-table-page">
                <transition name="fade" mode="out-in">
                    <div class="w-table-content" ref="tableContent" key="list">
                        <vxe-table
                            border
                            show-overflow
                            highlight-hover-row
                            :loading="tableObj.loading"
                            ref="xTable"
                            :data="tableObj.tableData"
                            auto-resize
                            resizable
                            height="auto"
                            align="center"
                        >
                            <vxe-column type="seq" width="60" title="序号"></vxe-column>
                            <vxe-column
                                field="sname"
                                title="规则名称"
                                min-width="110"
                                header-align="center"
                                align="left"
                            ></vxe-column>
                            <vxe-column
                                field="createUser"
                                title="创建人"
                                width="120"
                            ></vxe-column>
                            <vxe-column
                                field="createDate"
                                title="创建时间"
                                width="160"
                            ></vxe-column>
                            <vxe-column
                                field="updateUser"
                                title="最后编辑人"
                                width="120"
                            ></vxe-column>
                            <vxe-column
                                field="updateDate"
                                title="最后编辑时间"
                                width="160"
                            ></vxe-column>
                            <vxe-column field="age3" title="设置系统默认规则" width="150">
                                <template #default="{ row }">
                                    <vxe-radio
                                        name="n1"
                                        v-model="row.isDefault"
                                        @change="handleTool('default', row)"
                                        :label="1"
                                    ></vxe-radio>
                                </template>
                            </vxe-column>
                            <vxe-column field="status" title="状态" width="110">
                                <template #default="{ row }">
                                    <vxe-switch
                                        v-model="row.status"
                                        open-label="启用"
                                        close-label="停用"
                                        :open-value="1"
                                        :close-value="0"
                                        @change="handleTool('status', row)"
                                    ></vxe-switch>
                                </template>
                            </vxe-column>
                            <vxe-column field="tool" title="操作" width="110">
                                <template #default="{ row }">
                                    <vxe-button
                                        size="mini"
                                        icon="el-icon-search"
                                        status="primary"
                                        title="查看"
                                        type="text"
                                        @click="handleTool('view', row)"
                                    ></vxe-button>
                                    <vxe-button
                                        size="mini"
                                        icon="el-icon-edit"
                                        status="primary"
                                        title="编辑"
                                        type="text"
                                        @click="handleTool('edit', row)"
                                    ></vxe-button>
                                    <vxe-button
                                        size="mini"
                                        icon="el-icon-delete"
                                        status="primary"
                                        title="删除"
                                        type="text"
                                        :disabled="row.isDefault === 1"
                                        @click="handleTool('delete', row)"
                                    ></vxe-button>
                                </template>
                            </vxe-column>
                        </vxe-table>
                    </div>
                </transition>
            </div>
            <!-- 底部分页 -->
            <div class="w-table-footer">
                <vxe-pager
                    :loading="tableObj.loading"
                    :current-page="tableObj.current"
                    :page-size="tableObj.size"
                    :total="tableObj.total"
                    :layouts="[
                        'Total',
                        'Sizes',
                        'PrevPage',
                        'JumpNumber',
                        'NextPage',
                        'FullJump',
                    ]"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </div>
        </div>

        <!-- 新增、编辑等弹窗 -->
        <el-dialog
            :visible.sync="dialogObj.visible"
            :title="dialogObj.title"
            :width="dialogObj.width"
            :close-on-click-modal="false"
            @closed="handleClose"
        >
            <!-- 新增 第一步 输入规则名称 -->
            <template v-if="dialogObj.step === 1">
                <el-form
                    :model="addForm"
                    ref="addForm"
                    label-width="100px"
                    :show-message="false"
                >
                    <el-form-item label="规则名称" required prop="sname">
                        <el-input
                            v-model="addForm.sname"
                            placeholder="请输入"
                            maxlength="50"
                            show-word-limit
                            @blur="onSnameBlur"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </template>

            <!-- 第二步 打开具体规则 -->
            <template v-if="dialogObj.step === 2">
                <rule-table ref="ruleTable" :mode="dialogObj.mode"></rule-table>
            </template>

            <!-- footer 组件 -->
            <div
                slot="footer"
                class="dialog-footer text-center"
                v-if="dialogObj.mode !== 'view'"
            >
                <el-button size="small" @click="dialogObj.visible = false"
                    >取 消</el-button
                >
                <el-button
                    type="primary"
                    size="small"
                    :loading="dialogObj.btnLoading"
                    @click="doSave"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getBillRules, saveOrUpdateRule, ruleTools } from "@/api/modules/rule_setting.js";
import ruleTable from "./rule_table.vue";

export default {
    name: "",
    components: {
        ruleTable,
    },
    data() {
        return {
            searchForm: {
                title: "",
            },
            tableObj: {
                sname: "",
                current: 1,
                size: 10,
                tableData: [{}],
                total: 0,
                pageList: [10, 20, 50, 100], // 显示条数数组
            },
            // 弹窗
            dialogObj: {
                title: "",
                visible: false,
                width: "500px",
                mode: "add",
                step: 0,
                btnLoading: false,
            },
            // 新增规则
            addForm: {
                sname: "",
                id: "",
            },
        };
    },
    created() {
        // 初始查询
        this.onSearch();
    },
    methods: {
        onSearch() {
            let params = {
                current: this.tableObj.current,
                size: this.tableObj.size,
                sname: this.tableObj.sname,
            };
            this.tableObj.loading = true;

            getBillRules(params)
                .then((res) => {
                    this.tableObj.loading = false;
                    this.tableObj.tableData = res.data.records;
                    this.tableObj.total = parseInt(res.data.total);
                })
                .catch((err) => {
                    this.tableObj.loading = false;
                });
        },

        // 点击刷新
        onRefresh() {
            this.tableObj.size = 10;
            this.tableObj.current = 1;
            this.tableObj.sname = "";

            this.onSearch();
        },

        // 点击新增规则、查看规则、编辑规则、删除规则
        handleTool(type, row) {
            let params = {
                type: "",
                id: "",
            };
            // 保存成功消息
            let msg = "";

            switch (type) {
                // 新增规则
                case "add":
                    // console.log(this.tableObj.tableData);
                    this.dialogObj.step = 1;
                    this.dialogObj.title = "新增分析规则";
                    this.dialogObj.width = "500px";
                    this.dialogObj.visible = true;
                    return;
                // 设置默认规则
                case "default":
                    params.type = 3;
                    params.id = row.id;
                    msg = "设置成功！";
                    break;
                // 启用、停用
                case "status":
                    params.type = 2;
                    params.id = row.id;
                    params.status = row.status;
                    msg = "状态更改成功！";
                    break;
                // 查看
                case "view":
                    this.openRule("view", row);
                    return;
                // 编辑
                case "edit":
                    this.openRule("edit", row);
                    return;
                // 删除
                case "delete":
                    params.type = 1;
                    params.id = row.id;
                    msg = "删除成功！";
                    break;
            }

            // 接口操作
            if (type === 'delete') {
                this.$confirm("确认要删除当前数据吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        ruleTools(params)
                            .then((res) => {
                                this.$message.success(msg);
                                this.onSearch();
                            })
                            .catch((err) => {});
                    })
                    .catch(() => {
                        return
                    });
            } else {
                ruleTools(params)
                    .then((res) => {
                        this.$message.success(msg);
                        this.onSearch();
                    })
                    .catch((err) => {});
            }
        },

        // 规则名称失焦事件
        onSnameBlur() {
            this.addForm.sname = this.addForm.sname.replace(/\s+/g, "");
        },

        // 点击弹窗保存按钮
        doSave() {
            this.dialogObj.btnLoading = true;
            // 如果是第一步新增
            if (this.dialogObj.step === 1) {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.dialogObj.btnLoading = false;
                        // 进入第二步
                        this.openRule("add");
                    } else {
                        setTimeout(() => {
                            this.dialogObj.btnLoading = false;
                        }, 2000);
                    }
                });
            }

            // 如果是第二步 新增
            if (this.dialogObj.step === 2 && this.$refs.ruleTable) {
                // 检验是否合格
                this.$refs.ruleTable.checkSave().then((status) => {
                    if (status) {
                        let params = {
                            id: this.addForm.id,
                            sname: this.addForm.sname,
                            rules: undefined,
                            isSys: 1
                        };
                        params.rules = this.$utils.clone(
                            this.$refs.ruleTable.rules,
                            true
                        );

                        // 接口保存
                        saveOrUpdateRule(params)
                            .then((res) => {
                                this.dialogObj.btnLoading = false;
                                this.dialogObj.visible = false;
                            })
                            .catch((err) => {
                                setTimeout(() => {
                                    this.dialogObj.btnLoading = false;
                                }, 2000);
                            });
                    } else {
                        setTimeout(() => {
                            this.dialogObj.btnLoading = false;
                        }, 2000);
                    }
                });
                return;
            }
        },

        // 进入分析弹窗页面
        openRule(type, row) {
            this.dialogObj.step = 2;
            this.dialogObj.width = "1200px";

            switch (type) {
                case "add":
                    this.dialogObj.title = `新增分析规则 ( ${this.addForm.sname} )`;
                    break;
                case "view":
                    this.dialogObj.title = `查看分析规则 ( ${row.sname} )`;
                    break;
                case "edit":
                    this.dialogObj.title = `编辑分析规则 ( ${row.sname} )`;
                    break;
            }

            this.dialogObj.mode = type;
            this.dialogObj.visible = true;

            // 设置参数信息
            if (type !== "add") {
                this.addForm.id = row.id;
                this.addForm.sname = row.sname;

                setTimeout(() => {
                    this.$refs.ruleTable
                        ? (this.$refs.ruleTable.rules = this.$utils.clone(
                              row.rules,
                              true
                          ))
                        : "";
                    this.$refs.ruleTable ? this.$refs.ruleTable.setChecked() : "";
                }, 500);
            }
        },

        // 弹窗关闭事件
        handleClose() {
            // 弹窗对象
            this.dialogObj.step = 0;
            this.dialogObj.mode = "add";

            // 参数对象
            this.addForm.id = "";
            this.addForm.sname = "";

            // 重载表格
            this.onSearch();
        },

        // 切换分页查询
        handlePageChange({ currentPage, pageSize }) {
            this.tableObj.current = currentPage;
            this.tableObj.size = pageSize;

            this.onSearch();
        },
    },
};
</script>

<style scoped lang="less"></style>
